/*
	OneGWP 2.0.0 Usage (Webpack)
	Yang @onerockwell
	
	Simple rule based GWP
	Rule: has none gift item in cart, get the free gift (defined in theme settings)
*/

// Import all dependencies here
import Backbone from "backbone";
import OneSwiffySlider from "@/modules/module-oneSwiffySlider";

import "../../styles/modules/oneGWP.scss";
import { PUB_SUB_EVENTS, publish } from "@/lib/pubsub";

// // Define a new console, to enable debugging logs please set 1r_debugging cookie with value of true using `ORW.utilities.setCookie('1r_debugging',true)`
// const console = (function(oldCons){
// 	ORW.debugging = ORW.utilities.getCookie('1r_debugging');
//     return {
//         log: function(text){
//             ORW.debugging == `true` && oldCons.log(text);
//         },
//         info: function (text) {
//             ORW.debugging == `true` && oldCons.info(text);
//         },
//         warn: function (text) {
//             ORW.debugging == `true` && oldCons.warn(text);
//         },
//         debug: oldCons.debug,
//         error: function (text) {
//             oldCons.error(text);
//             if (window?.newrelic) {
//                 var err = new Error(text);
//                 window.newrelic.noticeError(err);
//             }
//         }
//     };
// }(window.console));

// Define the Backbone View here (Optional)
const OneGWPView = Backbone.View.extend({
  initialize: async function (settings) {
    const self = this;

    console.log(`GWP Config: Init GWP ...`);

    if (!ORW.GWP || ORW.GWP.enable != `true`) {
      console.log(`GWP Config: GWP is disabled`);
      return false;
    }

    // Global variables
    self.tiers = {};
    self.tiersAllVariants = [];
    self.defaultTierProduct = null;

    self.currentTier = null;
    self.currentFreeGift = null;

    // Rendering and GWP products data prep
    if (!self.prepDataAndRender()) return;

    // Start the cart watcher
    const myCartWatcher = new CartWatcher();
    myCartWatcher.init();
    window.addEventListener("cart_changed", async (e) => {
      console.log(`Cart updated !!!`);
      console.log(e.detail);
      const cartDetails = e.detail;
      await self.applyDiscountCode();
      if (cartDetails.currentCart) await self.validate(cartDetails.currentCart);
    });

    // Start the action watcher
    self.action = {};
    self.actionProxy = new Proxy(self.action, {
      set: function (target, key, value) {
        console.log(`GWP Action: ${key} - ${value}`);
        target[key] = value; // key will be `loading`, value will be boolean `true` or `false`
        if (value) {
          document.body.classList.add(`gwp-in-action`);
        } else {
          document.body.classList.remove(`gwp-in-action`);
        }
        return true;
      },
    });
    self.actionProxy.loading = false;
  },

  events: {
    "click .free-gift.active:not(.added) button": function (e) {
      e.preventDefault();
      const self = this;
      const variantId = e.currentTarget.getAttribute(`data-variant-id`);
      self.swapFreeGift(variantId);
    },
  },

  onCartUpdate: async function (e) {},

  prepDataAndRender: function () {
    const self = this;

    /*
			Assume one and only one section loaded
		*/
    const gwpModule = document.querySelector(`.gwp-module`);
    const gwpWrapper = document.querySelector(`.gwp-wrapper`);
    const freeGifts = document.querySelectorAll(
      `.free-gift-collections .free-gift`
    );
    const freeGiftsArray = Array.from(freeGifts);

    if (!gwpModule || !gwpWrapper || !freeGiftsArray.length) {
      console.log(`GWP Config: GWP not configured properly, GWP disabled`);
      return false;
    }

    // consider sort the free gifts by tier attribute
    freeGiftsArray.forEach((freeGift, index) => {
      const tierKey = freeGift.getAttribute(`data-tier`); // tier_1, tier_2, tier_3
      const tierKeyAttr = `data-${tierKey.replace(`_`, `-`)}`; // data-tier-1, data-tier-2, data-tier-3

      const variantId = freeGift.getAttribute(`data-variant-id`);
      const productHandle = freeGift.getAttribute(`data-handle`);

      if (!self.tiersAllVariants.includes(variantId)) {
        self.tiersAllVariants.push(variantId);
      }

      if (!self.tiers[tierKey]) {
        const threshold = gwpWrapper.getAttribute(tierKeyAttr)
          ? parseInt(gwpWrapper.getAttribute(tierKeyAttr)) * 100
          : 0;
        if (threshold) {
          self.tiers[tierKey] = {
            products: [],
            threshold: parseInt(threshold),
          };
        }
      }

      self.tiers[tierKey] &&
        self.tiers[tierKey].products.push({
          variantId: variantId,
          productHandle: productHandle,
        });
    });

    if (!Object.keys(self.tiers).length) {
      console.log(`GWP Config: No tier found, GWP disabled`);
      return false;
    }
    console.log(`GWP Config: Tiers configured`);
    console.log(self.tiers);
    console.log(`GWP Config: Tiers variants configured`);
    console.log(self.tiersAllVariants);

    // Set the default free gift product to the first product in the first tier
    self.defaultTierProduct =
      self.tiers[Object.keys(self.tiers)[0]].products[0];
    if (!self.defaultTierProduct || !self.defaultTierProduct.variantId) {
      console.log(`GWP Config: No free gift configured, GWP disabled`);
      return false;
    }
    console.log(
      `GWP Config: Default free gift product is ${self.defaultTierProduct.variantId} (variantId)`
    );

    // Inject the GWP module
    document.querySelectorAll(`.system-content-gwp`).forEach((el) => {
      el.insertAdjacentHTML(
        "afterbegin",
        `<div class="gwp-module-container">${gwpModule.innerHTML}</div>`
      );
    });

    self.initializeSlider();

    // Lazyload update
    window.ORW.lazyload && window.ORW.lazyload.update();

    return true;
  },

  initializeSlider: function () {
    document.querySelectorAll(`.gwp-wrapper`).forEach((slider) => {
      OneSwiffySlider(slider);
    });
  },

  validate: async function (items) {
    const self = this;
    let gwpCartTotal = 0;

    console.log(`GWP Validation: Cart validating ... `);

    if (items.length) {
      console.log(items);

      // If no DB25, use final prices (after any other discounts)
      gwpCartTotal = items.reduce((acc, item) => {
        // Exclude shipping protection (NuEthic) and GWP items from cart total calculation
        if (
          item.vendor === "NuEthic" ||
          (item.properties && item.properties._GWP)
        ) {
          return acc;
        }
        // Use final_line_price - if other discounts bring total below $500, gift is removed
        return acc + item.final_line_price;
      }, 0);
      console.log(`GWP Validation: Cart total (final prices) ${gwpCartTotal}`);

      // Determine if cart qualifies for GWP
      const validTiers = Object.keys(self.tiers).filter((tier) => {
        // Qualify ONLY if threshold is met
        return gwpCartTotal >= self.tiers[tier].threshold;
      });

      console.log(`GWP Validation: Valid tiers: ${validTiers}`);

      self.currentTier = validTiers.length
        ? validTiers[validTiers.length - 1]
        : null;

      // Perform validation actions
      await self.validationActions(validTiers, items);
    } else {
      self.currentTier = null;
      self.currentFreeGift = null;
      console.log(`GWP Validation: no action`);
    }

    self.updateMessage(gwpCartTotal);
  },

  getProductByhandle: async function (handle) {
    const self = this;
    try {
      const response = await fetch(
        `${window.Shopify.routes.root}products/${handle}.js`
      );
      const responseData = await response.json();
      return responseData;
    } catch (error) {
      console.log(error);
      return false;
    }
  },

  swapFreeGift: async function (variantId) {
    /*
			The strategy here is to use the update api to make the first call to remove the current free gift and add the new free gift
			then making a second call to update the line item property of the new free gift with `_GWP`

			The reason for this is that the update api does not allow to update the line item property directly, so we need to make two calls.
			More important, our validation is triggered at every cart update, which means we cannot just remove the current free gift then add
			the new one, since the validation will add the default free gift after the removal call.
		*/
    const self = this;
    let swapFlag = false;

    if (!variantId) {
      console.log(`GWP Action: No variantId provided for swapping`);
      return;
    }

    if (self.currentFreeGift && self.currentFreeGift.variant_id == variantId) {
      // Same free gift, no action
      console.log(`GWP Action: Same free gift, no action`);
      return;
    } else if (self.currentFreeGift) {
      // Do the swap
      console.log(`GWP Action: Swap free gift ...`);
      const url = window.Shopify.routes.root + "cart/update.js";
      const updates = {
        [self.currentFreeGift.variant_id]: 0,
        [variantId]: 1,
      };
      const config = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates }),
      };

      self.actionProxy.loading = true;
      try {
        const response = await fetch(url, config);
        self.GWPChanged(response, `gwp_gift_swapped`);
        swapFlag = true;
      } catch (error) {
        console.log(`GWP Action: Swap/Update free gift error`);
        console.log(error);
        swapFlag = false;
      }
      self.actionProxy.loading = false;
    } else {
      // Add the free gift
      console.log(`GWP Action: Add free gift ...`);
      await self.addFreeGift(variantId);
    }

    if (swapFlag) {
      const url = window.Shopify.routes.root + "cart/change.js";
      const formData = {
        id: `${variantId}`,
        properties: {
          _GWP: `true`,
        },
      };
      const config = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      };

      self.actionProxy.loading = true;
      try {
        const response = await fetch(url, config);
        self.GWPChanged(response, `gwp_gift_swap_updated`);
        // if (document.body.classList.contains(`template-cart`)) {
        // 	location.reload()
        // }
      } catch (error) {
        console.log(
          `GWP Action: Swap/Update free gift error (property update)`
        );
        console.log(error);
      }
      self.actionProxy.loading = false;
    }
  },

  addFreeGift: async function (variantId = null) {
    const self = this;
    const url = window.Shopify.routes.root + "cart/add.js";
    const id = variantId ? variantId : self.defaultTierProduct.variantId;
    const formData = {
      id: `${id}`,
      quantity: 1,
      properties: {
        _GWP: `true`,
      },
    };

    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    };

    self.actionProxy.loading = true;
    try {
      const response = await fetch(url, config);
      self.GWPChanged(response, `gwp_gift_added`);
      // if (document.body.classList.contains(`template-cart`)) {
      // 	location.reload()
      // }
    } catch (error) {
      console.log(`GWP Action: Adding free gift error`);
      console.log(error);
    }
    self.actionProxy.loading = false;
  },

  removeFreeGift: async function (variantId = null) {
    const self = this;
    const url = window.Shopify.routes.root + "cart/change.js";
    const id = variantId ? variantId : self.defaultTierProduct.variantId;

    const formData = {
      id: `${id}`,
      quantity: 0,
    };
    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    };

    self.actionProxy.loading = true;
    try {
      const response = await fetch(url, config);
      self.GWPChanged(response, `gwp_gift_removed`);
      // if (document.body.classList.contains(`template-cart`)) {
      // 	location.reload()
      // }
    } catch (error) {
      console.log(`GWP Action: Remove free gift error`);
      console.log(error);
    }
    self.actionProxy.loading = false;
  },

  updateFreeGift: async function (updates = {}) {
    /*
			updates = {
				'variant_id_1': 'qty_1',
				'variant_id_2': 'qty_2',
				...
			}
		*/
    const self = this;
    const url = window.Shopify.routes.root + "cart/update.js";
    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates }),
    };

    self.actionProxy.loading = true;
    try {
      const response = await fetch(url, config);
      self.GWPChanged(response, `gwp_gift_updated`);
      // if (document.body.classList.contains(`template-cart`)) {
      // 	location.reload()
      // }
    } catch (error) {
      console.log(`GWP Action: Reset/Update free gift error`);
      console.log(error);
    }
    self.actionProxy.loading = false;
  },

  validationActions: async function (validTiers, cartItems) {
    const self = this;
    const swapText = function (el) {
      if (!el) return;
      const temp = el.innerHTML;
      el.innerHTML = el.getAttribute(`alt-text`);
      el.setAttribute(`alt-text`, temp);
    };
    const freeGifts = document.querySelectorAll(
      `.free-gift-collections .free-gift`
    );
    const freeGiftInCart = cartItems.filter(
      (item) => item.properties && item.properties._GWP
    );
    self.currentFreeGift = freeGiftInCart.length ? freeGiftInCart[0] : null;

    // Reset the free gifts UI
    freeGifts.forEach((el) => {
      el.classList.remove("active", "added");
      const btn = el.querySelector(`button`);
      if (btn.classList.contains(`active`)) {
        btn.classList.remove(`active`);
        swapText(btn);
      }
    });

    if (validTiers.length) {
      // process valid tier actions
      console.log(`GWP Validation: Valid tiers - ${validTiers}`);
      console.log(`GWP Validation: Current valid tier - ${self.currentTier}`);

      // Update the free gifts UI, get the current free gift in cart if any
      validTiers.forEach((tier) => {
        const validTier = self.tiers[tier];
        validTier.products.forEach((product) => {
          const validFreeGift = document.querySelectorAll(
            `.free-gift-collections .free-gift[data-variant-id="${product.variantId}"]`
          );
          validFreeGift.forEach((el) => {
            el.classList.add("active");
            if (
              self.currentFreeGift &&
              self.currentFreeGift.variant_id == product.variantId
            ) {
              el.classList.add("added");
              const btn = el.querySelector(`button`);
              btn.classList.add(`active`);
              swapText(btn);
            }
          });
        });
      });

      console.log(
        `GWP Validation: Current free gift - ${self.currentFreeGift}`
      );

      if (!self.currentFreeGift) {
        // Has valid tier but no free gift in cart, add the first free gift from the lowest valid tier
        console.log(`GWP Action: add the default free gift ...`);
        await self.addFreeGift();
      } else {
        // Has valid tier with free gift in cart, check if the free gift in cart still valid
        console.log(
          `GWP Validation: Has valid tier with free gift in cart, check if the free gift in cart still valid ...`
        );

        // Validate: if the current free gift is in a higher tier, remove the free gift
        const currentFreeGiftTier = Object.keys(self.tiers).find((tier) => {
          return self.tiers[tier].products.some(
            (product) => product.variantId == self.currentFreeGift.variant_id
          );
        });
        console.log(
          `GWP Validation: Current free gift tier - ${currentFreeGiftTier}`
        );
        if (
          currentFreeGiftTier.toString().localeCompare(self.currentTier) > 0
        ) {
          // The current free gift is in a higher tier, remove the free gift
          console.log(
            `GWP Action: remove the free gift due to tier change ...`
          );
          await self.removeFreeGift(self.currentFreeGift.variant_id);
        }

        const qtyValidationUpdates = {};
        // Validate: if the current free gift has more than 1 quantity, reset the quantity to 1
        if (self.currentFreeGift.quantity > 1) {
          console.log(
            `GWP Validation: Current free gift has more than 1 quantity ...`
          );
          qtyValidationUpdates[self.currentFreeGift.variant_id] = 1;
        }

        // Validate: if the cart has more than one free gift, remove all free gift
        if (freeGiftInCart.length > 1) {
          console.log(`GWP Validation: Cart has more than one free gift ...`);
          freeGiftInCart.forEach((item) => {
            qtyValidationUpdates[item.variant_id] = 0;
          });
        }

        if (Object.keys(qtyValidationUpdates).length) {
          console.log(
            `GWP Action: Cart has exceeded amount of free gifts, reset the free gifts ...`
          );
          console.log(qtyValidationUpdates);
          await self.updateFreeGift(qtyValidationUpdates);
        }
      }
    } else {
      // process non-valid tier actions
      console.log(`GWP Validation: no valid tier ...`);
      if (self.currentFreeGift) {
        console.log(
          `GWP Action: remove the free gift due to no valid tier ...`
        );
        await self.removeFreeGift(self.currentFreeGift.key);
      } else {
        console.log(`GWP Action: no action`);
      }
    }
  },

  updateMessage: function (gwpCartTotal) {
    const self = this;
    const messagesBlocks = document.querySelectorAll(
      `.gwp-module-container .gwp-message`
    );

    if (self.currentTier) {
      messagesBlocks.forEach((el) => {
        el.innerHTML = `${el.attributes["data-message-qualify"].value}`;
      });
    } else {
      const firstTier = Object.keys(self.tiers).length
        ? self.tiers[Object.keys(self.tiers)[0]]
        : false;
      console.log(firstTier);

      if (firstTier && firstTier.threshold > gwpCartTotal) {
        const amountLeft = parseInt(firstTier.threshold - gwpCartTotal);
        messagesBlocks.forEach((el) => {
          const defaultMessage = el.attributes[
            "data-message-default"
          ].value.replace(
            `__`,
            Shopify.formatMoney(amountLeft, window.theme.moneyFormat)
          );
          el.innerHTML = `${defaultMessage}`;
        });
      }
    }
  },

  GWPChanged: function (data = {}, eventNameOverride = "") {
    const eventName = eventNameOverride ? eventNameOverride : `gwp_changed`;
    const event = new CustomEvent(eventName, { detail: data });
    window.dispatchEvent(event);
  },

  destroy: function () {
    const self = this;
    self.undelegateEvents();
  },
  applyDiscountCode: async function () {
	console.log("Checking and applying discount code if needed...");
	const cart = await fetch('/cart.js').then(res => res.json());
    const discountCode = ORW.bfcm_discount_code;
    if (!discountCode) return;
    const hasDiscount =
      cart.discount_codes &&
      cart.discount_codes.some(
        (d) => d.code && d.code.toUpperCase() === discountCode.toUpperCase()
      );

    if (!hasDiscount) {
      console.log("Discount not applied, applying now... PDP page");
      // Discount not applied, apply it
      return fetch(`/discount/${discountCode}`).then(function () {
        // Force the cart to update so the discount is visible
        return fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            updates: {},
          }),
        });
      });
    } else if (hasDiscount) {
      console.log("Discount already applied PDP page");
    } else {
      console.log("Cart is empty, skipping discount PDP page");
    }
  },
});

// Define the module here
const OneGWP = {
  init: function (settings) {
    // If using Backbone View
    return new OneGWPView({
      el: document.body,
    });

    // If not using Backbone View
    // return this;
  },
};

// Output the module
export default OneGWP;

class CartWatcher {
  init() {
    this.emitCartChanges().then(() => {
      this.observeCartChanges();
    });
  }

  async fetchCart() {
    const response = await fetch("/cart.js");
    return response.json();
  }

  storeCart(cart) {
    localStorage.setItem("cart", JSON.stringify(cart));
  }

  storedCart() {
    return JSON.parse(localStorage.getItem("cart")) || { items: [] };
  }

  findCartChanges(oldCart, newCart) {
    const onlyInLeft = (l, r) =>
      l.filter((li) => !r.some((ri) => li.key == ri.key));
    let result = {
      added: onlyInLeft(newCart.items, oldCart.items),
      removed: onlyInLeft(oldCart.items, newCart.items),
      currentCart: newCart.items,
    };

    oldCart.items.forEach((oi) => {
      const ni = newCart.items.find(
        (i) => i.key == oi.key && i.quantity != oi.quantity
      );
      if (!ni) return;
      let quantity = ni.quantity - oi.quantity;
      let item = { ...ni };
      item.quantity = Math.abs(quantity);
      quantity > 0 ? result.added.push(item) : result.removed.push(item);
    });

    return result;
  }

  async stall(milliseconds) {
    return new Promise((resolve) => {
      setTimeout(resolve, milliseconds);
    });
  }

  async emitCartChanges() {
    await this.stall(200); // Wait a few before getting the cart as the request could be WIP.
    const newCart = await this.fetchCart();
    const oldCart = this.storedCart();
    const changes = this.findCartChanges(oldCart, newCart);

    const event = new CustomEvent("cart_changed", { detail: changes });
    window.dispatchEvent(event);

    this.storeCart(newCart);
  }

  observeCartChanges() {
    const cartObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach(async (entry) => {
        const isValidRequestType = ["xmlhttprequest", "fetch"].includes(
          entry.initiatorType
        );
        const isCartChangeRequest = /\/cart\//.test(entry.name);
        if (isValidRequestType && isCartChangeRequest) {
          await this.emitCartChanges();
        }
      });
    });
    cartObserver.observe({ entryTypes: ["resource"] });
  }
}
